// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Filter as RawFilter } from "lucide-react";
export const Filter = /* @__PURE__ */ createIcon(RawFilter, "Filter", 2);
